module.exports = __webpack_public_path__ + "img/DatabaseRefresh.f8c19b46.svg";